import {
	FacebookAuthProvider,
	getAuth,
	linkWithCredential,
	OAuthCredential,
} from 'firebase/auth';

import { usePendingCredentialStore } from './usePendingCredentialStore';

export async function linkPendingCredential() {
	const auth = getAuth();
	const user = auth.currentUser;

	if (!user) return;

	const { pendingCredential, resetPendingCredential } =
		usePendingCredentialStore.getState();
	const { providerId, token, email } = pendingCredential;

	if (!providerId || !token || !email || email !== user.email) return;

	const credential: OAuthCredential = FacebookAuthProvider.credential(token);

	if (!credential) return;

	await linkWithCredential(user, credential);
	resetPendingCredential();
}
